import { FC, createContext, useContext } from 'react'
import { WithChildren } from '../helpers'
import { getStoredLanguage, setStoredLanguage, SupportedLanguage } from '../../app/utils/languageStorage'

type Props = {
  selectedLang: SupportedLanguage
}
const initialState: Props = {
  selectedLang: 'en',
}

function getConfig(): Props {
  return { selectedLang: getStoredLanguage() }
}

// Side effect
export function setLanguage(lang: string) {
  setStoredLanguage(lang)
  window.location.reload()
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

const MetronicI18nProvider: FC<WithChildren> = ({ children }) => {
  const lang = getConfig()
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export { MetronicI18nProvider, useLang }
